import type { DashboardSnapshot, LabSnapshot, TimeScope } from '#shared/types';
import { api } from '#client/lib/api';
import { type KeyedRequest, useKeyedRequest } from '#client/hooks/useKeyedRequest';
import { ENDPOINT } from '#client/lib/endpoints';

/** The dashboard snapshot for a time scope. */
export function useDashboard(scope: TimeScope): KeyedRequest<DashboardSnapshot> {
  return useKeyedRequest<DashboardSnapshot>(
    scope,
    (signal) => api.get<DashboardSnapshot>(ENDPOINT.dashboard, { scope }, signal),
    'Could not load the dashboard',
  );
}

/** The lab's size, fetched only once `open` — the card it fills starts collapsed. */
export function useLabSnapshot(open: boolean): KeyedRequest<LabSnapshot> {
  return useKeyedRequest<LabSnapshot>(
    open ? 'lab-snapshot' : undefined,
    (signal) => api.get<LabSnapshot>(ENDPOINT.dashboardSnapshot, undefined, signal),
    'Could not load the lab snapshot',
  );
}
